import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  token: string;
};

const [useDeleteApiToken, deleteApiToken] = createAsyncAction(
  "apiTokens/delete",
  async ({ token }: Args) => {
    const res = await API.call<{ token: string }>({
      endpoint: `api-tokens/${token}`,
      method: "DELETE",
    });

    return { ...res, result: res.result.token };
  }
);
export default useDeleteApiToken;
export { deleteApiToken };
